import { useState } from 'react'

import { store } from 'redux/store'

import CardService from 'services/card.service'

import { useActionless } from 'redux/hooks'
import { SET_ACTIVE_STATE } from 'redux/active/actions/types'

import StyledComponentThemeWrapper from 'components/misc/StyledComponentThemeWrapper'
import { GenericCursorCardWrapper } from 'components/card/CursorCardWrapper'
import { CardType, defaultCard } from 'types/deck'

import { generateTabState } from 'types/searchV2'

import styles from './inlineCardPreview.module.scss'

type Props = {
  name: string
  children: React.ReactNode
}

const CardLink = ({ name, children }: Props) => {
  const [card, setCard] = useState<CardType | null>()
  const [searched, setSearched] = useState(false)

  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  const handleFetchCardData = () => {
    if (searched) return null

    // Check the deck store prior to attempting to pull down a card.
    // This forces the edition to match (which is nice in itself), but also allows us to not have to hit the API
    const { cardMap } = store.getState().deck
    const card = Object.values(cardMap).find(card => card.name === name)

    if (!!card) return setCard(card)

    return CardService.listCardsOnly({ name, exact: true })
      .then(cards => setCard(cards[0] || null))
      .catch(err => console.error(err))
      .finally(() => setSearched(true)) // Even if it fails, just mark it searched. We don't want it constantly spinning if something is wrong
  }

  const handleCardClick = () => {
    const newSearchTab = generateTabState.archidektSearch()

    // @ts-ignore
    newSearchTab.meta.name = name
    // @ts-ignore
    newSearchTab.meta.exact = true

    setActiveState({ searchOpen: newSearchTab })
  }

  return (
    <StyledComponentThemeWrapper>
      <GenericCursorCardWrapper card={card || defaultCard} onHoverStart={handleFetchCardData} isDragging={false}>
        <span className={styles.cardLink} spellCheck={false} onClick={handleCardClick}>
          {children}
        </span>
      </GenericCursorCardWrapper>
    </StyledComponentThemeWrapper>
  )
}

export default CardLink
